import { Ensure } from '@/core/async/Ensure';
import outstandingRequestsService from '@/core/http/outstandingRequests.service';

// Set window.prerenderReady to true when all initial XHR requests from header/page has settled
const prerenderReadyQuietPeriodMs = 1000;

declare global {
    interface Window {
        prerenderReady: boolean
    }
}

window.prerenderReady = false;

void setPrerenderReadyWhenRequestsSettle();

async function setPrerenderReadyWhenRequestsSettle() {
    const ensure = new Ensure(() => {
        const hasBeenQuietLongEnough = Date.now() - outstandingRequestsService.prerenderLastChangedAt >= prerenderReadyQuietPeriodMs;

        return !outstandingRequestsService.hasOutstandingPrerenderRequests && hasBeenQuietLongEnough;
    }, 5000);

    try {
        await ensure.start();
    } catch {
        // Timeout — proceed anyway so prerendering is not blocked indefinitely
    }
    window.prerenderReady = true;
}
